<template>
  <ValidationObserver v-slot="{ invalid, handleSubmit }" slim>
    <form @submit.prevent="handleSubmit(saveRecupBonus)" class="justify-content-between col-lg-12 py-3">
      <div class="form-row align-items-center py-3">
        <DateInputField
            class="col-lg-3 col-md-12"
            v-model="date"
            labelText="datum" required
            vid="date"/>
        <NumberInputField
            class="col-lg-3 col-md-12"
            labelText="uren" required
            id="uren"
            step=".01"
            v-model="hours"/>
        <TextInputField
            class="col-lg-3 col-md-12"
            v-model="reason" labelText="reden"/>
        <div class="col-lg-3 col-md-12">
          <div>
            <button
                type="submit" :disabled="invalid"
                class="btn-basic btn-fill-pulse" >
              Opslaan
            </button>
          </div>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import {mapActions} from "vuex";
import {ValidationObserver} from "vee-validate";
import DateInputField from "@/components/inputFields/DateInputField";
import NumberInputField from "@/components/inputFields/NumberInputField";
import TextInputField from "@/components/inputFields/TextInputField.vue";

export default {
  name: "CreateRecupBonusFormComponent",
  components: {
    TextInputField,
    NumberInputField,
    DateInputField,
    ValidationObserver
  },
  data() {
    return {
      date: "",
      hours: 0.00,
      reason: ""
    };
  },
  methods: {
    ...mapActions("administrationUser",["createRecupBonus","fetchRecupForYear"]),
    saveRecupBonus() {
      const CreateRecupBonusDto = {
        date: this.date,
        reason: this.reason,
        hours: this.hours
      };
      this.createRecupBonus(CreateRecupBonusDto)
          .then(()=>this.fetchRecupForYear());
    },
    resetFields() {
      this.date = "";
      this.hours = 0.00;
      this.reason = "";
    }
  }
};
</script>

<style scoped>

.text-red {
  color: red;
}

</style>
